export default __webpack_public_path__ + "static/media/ogm-masterImage.80a874b4.jpeg";